import styles from "./card.module.scss";
import React from "react";

interface CardProps {
    id?:any;
    children?: any;
}

export const Card: React.FC<CardProps> = ({
    id,
    children
}) => {
    return (
        <div id={id} className={styles.card}>
            {children}
        </div>
    );
};
